import { LabelWithUnit } from 'components/secondaryMarket/shared/Label';
import { VerticalFormGroup } from 'components/secondaryMarket/shared/VerticalFormGroup';
import { AmountWithUnit } from 'components/shared/Amount/Amount';
import type { LivePostEventPricingInformationProps } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/live/sections.ts/LivePostEventPricingInformation.connect';

export function LivePostEventPricingInformation({
  settlementPrice,
  amountUnit,
  accruedInterest,
  salesMarginPlusUpfront,
}: LivePostEventPricingInformationProps) {
  return (
    <>
      {settlementPrice !== undefined && (
        <VerticalFormGroup
          inputId="settlementPrice"
          label="secondaryMarket.tradeInformation.label.settlementPrice"
          className="col"
        >
          <AmountWithUnit
            value={settlementPrice}
            unit={amountUnit}
            e2e="settlementPrice"
            isReadOnly
            decimalPadding={false}
            precision={4}
            tabIndex={4}
          />
        </VerticalFormGroup>
      )}

      {accruedInterest !== undefined && (
        <VerticalFormGroup
          inputId="accruedInterest"
          label="secondaryMarket.saleMarginInformation.accruedInterest"
          className="col"
        >
          <LabelWithUnit
            id="accruedInterest"
            value={accruedInterest.toFixed(4)}
            unit={amountUnit}
            e2e="sales-margin-plus-upfront"
          />
        </VerticalFormGroup>
      )}
      {salesMarginPlusUpfront !== undefined && (
        <VerticalFormGroup
          inputId="salesMarginPlusUpfront"
          label="secondaryMarket.saleMarginInformation.salesMarginPlusUpfront"
          className="col-4"
        >
          <LabelWithUnit
            id="salesMarginPlusUpfront"
            value={salesMarginPlusUpfront.toFixed(4)}
            unit={amountUnit}
            e2e="sales-margin-plus-upfront"
          />
        </VerticalFormGroup>
      )}
    </>
  );
}
